import React from 'react';

export const Reel_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Reel Post</span>,
  },
];

export const ReelSub_Title = [
  {
    textSize: '1rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        The pieces showcased are part of the work produced by KUTER Casa
        Productora in collaboration with various clients. All intellectual
        property rights to the works belong to their respective owners.
      </span>
    ),
  },
];

export const Betcris_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>BETCRIS - NO IMPORTA EL DEPORTE</span>,
  },
];

export const Charly_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Charly</span>,
  },
];

export const ImagenRadio_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Imagen Radio</span>,
  },
];

export const Teleton_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Teletón</span>,
  },
];

export const Interceramic_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Interceramic</span>,
  },
];

export const Lg_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>LG</span>,
  },
];

export const Warner_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Warner Music</span>,
  },
];
